// File created by Reginald Sahil Chand on 26-03-2024.

import React from 'react';

import {
	MdAssignmentLate,
	MdCreate,
	MdDeleteForever,
	MdDone,
	MdHomeFilled,
	MdLabelImportant,
	MdPendingActions,
} from 'react-icons/md';

import {type TaskNavigationDataProps} from '../types/data/taskNavigationDataTypes';

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Export an array of objects (tasks navigation title and icon),
 * 				which can be mapped later as and where required.
 *
 * @type {TaskNavigationDataProps}
 * @version 0.1.0
 */
export const taskNavigationData: TaskNavigationDataProps[] = [
	{
		title: 'Create Task',
		description: 'Click To Create A Task',
		icon: <MdCreate />,
	},

	{
		title: 'All Tasks',
		description: 'Click To View All The Tasks',
		icon: <MdHomeFilled />,
	},

	{
		title: 'Important',
		description: 'Click To View Important Tasks',
		icon: <MdLabelImportant />,
	},

	{
		title: 'Pending',
		description: 'Click To View Pending Tasks',
		icon: <MdPendingActions />,
	},

	{
		title: 'Overdue',
		description: 'Click To View Overdue Tasks',
		icon: <MdAssignmentLate />,
	},

	{
		title: 'Completed',
		description: 'Click To View Completed Tasks',
		icon: <MdDone />,
	},

	{
		title: 'Trash',
		description: 'Click To See Your Deleted Tasks',
		icon: <MdDeleteForever />,
	},

	{
		title: 'Settings',
		description: 'Click To Update Preferences',
		icon: <MdDeleteForever />,
	},
];
